/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
document.addEventListener("DOMContentLoaded", function() {
    function smoothScroll(triggerSelector, targetSelector, offset = 100) {
    const triggers = document.querySelectorAll(triggerSelector);
  
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
  
        // find the closest section (so it scrolls to the correct slider in that section)
        const section = trigger.closest('section') || document;
  
        const target = section.querySelector(targetSelector);
        if (!target) return;
  
        const targetY =
          target.getBoundingClientRect().top + window.pageYOffset - offset;
  
        window.scrollTo({
          top: targetY,
          behavior: 'smooth'
        });
      });
    });
  }
  
 
  // Existing link
  smoothScroll('a.hero__rating-link', '.testimonials-section');
  

  
  var anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])');

  for (var i = 0; i < anchors.length; i++) {
    anchors[i].addEventListener("click", function(e) {

      var offset = window.innerWidth <= 768 ? -220 : -250;

      if (this.hash) {
        var id = this.hash.substring(1);
        var target = document.getElementById(id);

        if (target) {
          e.preventDefault();

          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset + offset;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
          });
        }
      }
    });
  }

});

/* ============================================================
   Chocbox: clicking a variant jumps the product gallery (Slick
   carousel) to that variant's image.
   Paste this at the very BOTTOM of assets/custom.js
   (Online Store > Themes > ... > Edit code > assets/custom.js)
   ============================================================ */
(function () {
  function jumpToVariantImage() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return; // only runs on product pages (Slick is loaded there)

    var jsonEl = document.querySelector('[data-product-json]');
    var $slider = $('[data-product-single-media-slider]').filter('.slick-initialized').first();
    if (!jsonEl || !$slider.length) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    // Read the currently selected option values (flavor buttons are radio inputs)
    var values = [];
    document.querySelectorAll('[data-single-option-selector]').forEach(function (el) {
      if (el.type === 'radio') { if (el.checked) values.push(el.value); }
      else values.push(el.value);
    });

    // Find the matching variant
    var variant = product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return values[i] === opt; });
    });
    if (!variant || !variant.featured_media) return;

    // Find the slide showing this variant's image and slide to it
    var mediaId = String(variant.featured_media.id);
    var index = -1;
    $slider.find('[data-media-id]').each(function () {
      var id = this.getAttribute('data-media-id') || '';
      if (id.indexOf(mediaId) !== -1) {
        var $slide = $(this).closest('.slick-slide');
        if ($slide.length && !$slide.hasClass('slick-cloned')) {
          index = $slide.data('slick-index');
        }
      }
    });
    if (index > -1) $slider.slick('slickGoTo', index);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-single-option-selector]')) {
      setTimeout(jumpToVariantImage, 50);
    }
  });
})();
  